// ES6 Modules or TypeScript
import Swal from 'sweetalert2/dist/sweetalert2';
import settings from './settings';

export default function confirmWithoutCancel(options, onConfirm) {
  Swal.fire({
    ...settings,
    showConfirmButton: true,
    showCancelButton: false,
    ...options,
  }).then((result) => {
    if (result.isConfirmed) {
      onConfirm();
    }
  });
}
